(function () {
  'use strict';

  function tryPlay(video) {
    if (!(video instanceof HTMLVideoElement)) return;

    try {
      video.muted = true;
      video.defaultMuted = true;
      video.autoplay = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
    } catch (_e) {}

    var playPromise;
    try {
      playPromise = video.play();
    } catch (_e) {
      return;
    }

    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function playAll(root) {
    var scope = root || document;
    scope.querySelectorAll('video[autoplay][muted]').forEach(tryPlay);
  }

  function initVisibilityReplay() {
    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        tryPlay(entry.target);
      });
    }, { threshold: 0.25 });

    document.querySelectorAll('video[autoplay][muted]').forEach(function (video) {
      observer.observe(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      playAll(document);
      initVisibilityReplay();
    });
  } else {
    playAll(document);
    initVisibilityReplay();
  }

  document.addEventListener('shopify:section:load', function () {
    playAll(document);
  });

  ['touchstart', 'click', 'scroll'].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      playAll(document);
    }, { once: true, passive: true });
  });
})();
